import { ButtonProps } from '@mui/material';

import { NavigationItem } from '../types';

export const getExternalButtonProps = ({
  StartIcon,
  amount,
  isActive,
  isComingSoon,
  isDisabled,
  isEnabled,
  isHidden,
  isNew,
  isNotLinkItem,
  requiresPermission,
  ...props
}: NavigationItem): ButtonProps<'a', { component: 'a' }> => ({
  ...props,
  component: 'a',
  disabled: !isEnabled && !isComingSoon && (!props.href || isDisabled),
  href: props.href,
  onClick: props.onClick,
  rel: 'noopener noreferrer',
  target: '_blank',
  variant: 'text',
});
